<header class="text-center mb-4" *ngIf="!showCamperApplication">
  <h1 class="page-title blue">We can't wait</h1>
  <h1 class="page-title blue">to Welcome You</h1>
  <h1 class="page-title blue">to Our Pack!</h1>
</header>
<header class="text-center mb-4" *ngIf="showCamperApplication">
  <div class="lato bold">Interview Request Submitted</div>
</header>
<div class="text content-text">
  You will be contacted shortly by a Camp Bow Wow<sup>&#174;</sup> representative to schedule a
  day and time for this interview.
</div>
<ng-container *ngIf="showCamperApplication">
  <div class="text content-text">
    Reminder: <br>
    Signed Terms & Policies are required in order to bring your dog for their interview. Please review and sign the Terms & Policies prior to your dogs Interview
  </div>
  <div class="m-auto">
      <app-camper-app-page [showText]="false" ></app-camper-app-page>
  </div>
</ng-container>
<footer
  class="footer-action"
  style="margin-top: 2rem"
>
  <button
    *ngIf="!showCamperApplication"
    type="button"
    class="btn btn-danger btn-block"
    (click)="navigateToLandingPage()"
  >
    Return Home
  </button>
  <div
    *ngIf="showCamperApplication"
    class ="link oswald"
    (click)="navigateToLandingPage()"

  >Skip for Now</div>
</footer>
